import React, { PropTypes } from 'react';

import { organiserFullPropTypeShape } from '../../../../proptypes';
import schemaResolver from '../../../../state/resolvers/schema/organiser';

import Meta from '../../../../containers/Meta';

/**
 * Organiser detail page meta presentational component.
 **/
const OrganiserDetailPageMeta = (organiser) => {
  const {
    canonical,
    excerpt,
    images,
    query,
    title,
  } = organiser;
  return (
    <Meta
      title={title}
      description={excerpt}
      facebookImage={images && images.logo && images.logo.facebook}
      twitterImage={images && images.logo && images.logo.twitter}
      canonical={canonical}
      queries={[query]}
      schemata={schemaResolver(organiser)}
    />
  );
};

OrganiserDetailPageMeta.propTypes = {
  /**
   * String canonical to the organiser page.
   */
  canonical: organiserFullPropTypeShape.canonical, // eslint-disable-line max-len, react/require-default-props
  /**
   * String excerpt of organiser.
   */
  excerpt: organiserFullPropTypeShape.excerpt,
  /**
   * Object of images associated with the organiser.
   */
  images: organiserFullPropTypeShape.images,
  /**
   * Query for events associated with this organiser
   */
  queries: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  /**
   * String title of the organiser.
   */
  title: organiserFullPropTypeShape.title, // eslint-disable-line react/require-default-props
};

OrganiserDetailPageMeta.defaultProps = {
  excerpt: undefined,
  images: undefined,
};

export default OrganiserDetailPageMeta;



// WEBPACK FOOTER //
// ./app/src/components/OrganiserDetailPage/components/OrganiserDetailPageMeta/index.jsx